import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { carHireOptionPropType } from 'components/CarHire/shapes';
import CarFeatureList from 'components/CarHire/CarFeatureList';
import { camelCase } from 'utils/utils';
import { openSubModal } from 'redux/actions/modalActions';
import { CAR_TERMS_AND_CONDITIONS } from 'constants/modal';
import { SLIDE_DIRECTION_LEFT } from 'components/Modal/SlideInFromTheSideModal';
import CarHireProviderLogo from 'components/CarHire/CarHireProviderLogo';
import * as optimizelyUtil from 'utils/optimizely';

import './HireCarInfo.desktop.scss';
import './HireCarInfo.mobile.scss';

const mapDispatchToProps = dispatch => ({
  onOpenTermsAndConditions: carId => dispatch(openSubModal(CAR_TERMS_AND_CONDITIONS, {
    subPageIfMobile: 'car-hire-terms',
    slideInFromTheSide: SLIDE_DIRECTION_LEFT,
    title: 'Terms and Conditions',
    width: 800,
    carId,
  })),
});

export class HireCarInfo extends Component {
  static propTypes = {
    carHireOption: carHireOptionPropType.isRequired,
    onOpenTermsAndConditions: PropTypes.func.isRequired,
  };

  handleTermsAndConditionsClick = (event) => {
    event.preventDefault();

    const { carHireOption, onOpenTermsAndConditions } = this.props;
    optimizelyUtil.fireEvent('OfferSummaryCarHireTermsAndConditions', 'clicked');
    onOpenTermsAndConditions(carHireOption.get('id'));
  };

  render() {
    const { carHireOption } = this.props;

    return (
      <div className="hire-car-info">
        <div className="hire-car-info__images">
          <img className="hire-car-info__car-image" src={carHireOption.get('imageUrl')} />
          <div>
            <CarHireProviderLogo
              provider={carHireOption.get('provider')}
              providerCode={carHireOption.get('providerCode')}
            />
          </div>
        </div>
        <div className="hire-car-info__details">
          <div className="hire-car-info__name">{ camelCase(carHireOption.get('name')) }</div>
          <div className="hire-car-info__features">
            <CarFeatureList carHireOption={carHireOption} />
          </div>
          <div className="hire-car-info__terms-link">
            <a href={carHireOption.get('termsAndConditions')} onClick={this.handleTermsAndConditionsClick}>
              Full Terms and Conditions
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(undefined, mapDispatchToProps)(HireCarInfo);



/** WEBPACK FOOTER **
 ** ./src/components/CarHire/HireCarInfo.jsx
 **/